import Preloader from "@/ui-components/ui/preloader";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const Contacts = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/contacts/persons");
  }, [navigate]);

  return <Preloader />;
};

export default Contacts;
